import { useState } from "react";
import { hotComments } from "@/mocks/homeData";
import { SectionHead } from "./kit";

export default function Voices() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  return (
    <section id="voices" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-7 md:px-6 md:py-10">
        <SectionHead
          kicker="VOICES · 多方说法"
          title="观点交锋 · 读者在聊什么"
          tone="secondary"
          extra={
            <button
              type="button"
              className="hidden items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-sm text-foreground-600 whitespace-nowrap transition-colors hover:border-accent-300 hover:text-accent-700 md:inline-flex"
            >
              <i className="ri-chat-3-line" />
              参与讨论
            </button>
          }
        />

        <div className="grid gap-5 lg:grid-cols-3">
          {hotComments.map((c) => {
            const on = !!liked[c.id];
            return (
              <figure
                key={c.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-shadow hover:border-secondary-300"
              >
                <blockquote className="flex-1">
                  <i className="ri-double-quotes-l text-lg text-secondary-400" />
                  <p className="-mt-1 text-sm leading-relaxed text-foreground-800">“{c.text}”</p>
                </blockquote>
                <figcaption className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <div className="flex items-center gap-2.5">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                      {c.name.slice(0, 1)}
                    </span>
                    <div className="leading-tight">
                      <p className="text-[13px] font-semibold text-foreground-900">{c.name}</p>
                      <p className="text-[11px] text-foreground-400">{c.tag} · {c.time}</p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setLiked((p) => ({ ...p, [c.id]: !on }))}
                    className={`inline-flex cursor-pointer items-center gap-1 rounded-full px-2.5 py-1 text-xs transition-colors ${
                      on ? "bg-accent-100 text-accent-700" : "bg-background-100 text-foreground-500 hover:text-accent-600"
                    }`}
                  >
                    <i className={on ? "ri-thumb-up-fill" : "ri-thumb-up-line"} />
                    {c.likes}
                  </button>
                </figcaption>
              </figure>
            );
          })}
        </div>

        {/* CTA band */}
        <div className="mt-8 overflow-hidden rounded-lg bg-primary-950">
          <div className="relative flex flex-col items-start justify-between gap-5 px-6 py-7 md:flex-row md:items-center md:px-8">
            <div className="relative z-10 max-w-2xl">
              <p className="font-label text-[11px] font-bold tracking-[0.2em] text-accent-400">JOIN THE TRACE</p>
              <h3 className="mt-1.5 font-heading text-xl font-bold text-background-50 md:text-2xl">
                有线索，想一起把一件事追清楚？
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-100/70">
                匿名提交线索、公开存档与素材，编辑部会先做证据核实再纳入专题，避免单方面下判断。
              </p>
            </div>
            <div className="relative z-10 flex flex-wrap gap-2.5">
              <button
                type="button"
                className="inline-flex cursor-pointer items-center gap-2 rounded-full bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-accent-600"
              >
                <i className="ri-send-plane-line" />
                提交一条线索
              </button>
              <button
                type="button"
                className="inline-flex cursor-pointer items-center gap-2 rounded-full border border-background-50/25 px-5 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/10"
              >
                <i className="ri-notification-3-line" />
                订阅专题更新
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}